import React from 'react';

import { CustomSelectSkeleton } from '../../../../components/CustomSelect';
import { ToggleItemSkeleton } from '../ToggleItem';

const SalaryNotificationSettingsSkeleton: React.FC = () => {
    return (
        <section className="notifications-settings__category">
            <div className="notifications-settings__content-wrapper">
                <div className="notifications-settings__salary-notifications">
                    <ToggleItemSkeleton heightOverride={51} asHeader withSubLabel />
                    <CustomSelectSkeleton />
                </div>
            </div>
        </section>
    );
};

export default SalaryNotificationSettingsSkeleton;
